(function () {
  'use strict';
  function groupFor(form) {
    return form && form.querySelector('[data-bp-personalization]');
  }
  function validate(form, report) {
    var group = groupFor(form);
    if (!group) return true;
    var fields = Array.from(group.querySelectorAll('input'));
    var gap = false;
    fields.forEach(function (field) {
      field.setCustomValidity('');
      var value = field.value;
      if (field.hasAttribute('data-bp-name')) {
        if (value.length && !value.trim()) field.setCustomValidity(group.dataset.bpError);
        if (value.trim() && gap) field.setCustomValidity(group.dataset.bpGapError);
        if (!value.trim()) gap = true;
      }
      if (field.hasAttribute('data-bp-year') && !/^[0-9]{4}$/.test(value)) {
        field.setCustomValidity(group.dataset.bpError);
      }
      if (field.hasAttribute('data-bp-single-name') && !value.trim()) {
        field.setCustomValidity(group.dataset.bpError);
      }
    });
    var valid = form.checkValidity();
    var error = group.querySelector('[data-bp-personalization-error]');
    if (error) {
      error.hidden = valid;
      error.textContent = valid ? '' : group.dataset.bpError;
    }
    if (!valid && report) form.reportValidity();
    return valid;
  }
  function renderProperties(container, item) {
    if (!container) return;
    var properties = item && item.properties || {};
    container.querySelectorAll('.bp-cart-property').forEach(function (element) { element.remove(); });
    Object.keys(properties).forEach(function (key) {
      if (key.charAt(0) === '_' || properties[key] == null || !String(properties[key]).trim()) return;
      var row = document.createElement('div');
      row.className = 'bp-cart-property';
      row.style.cssText = 'display:block;margin-top:6px;font-size:14px;line-height:1.5;overflow-wrap:anywhere;';
      row.setAttribute('data-bp-rendered-property', '');
      var label = document.createElement('strong');
      label.textContent = key + ': ';
      row.appendChild(label);
      var value = String(properties[key]);
      var uploadURL;
      if (value.indexOf('/uploads/') !== -1) {
        try {
          var url = new URL(value, window.location.href);
          if (url.protocol === 'https:' || url.protocol === 'http:') uploadURL = url.href;
        } catch (error) { uploadURL = null; }
      }
      if (uploadURL) {
        var link = document.createElement('a');
        link.href = uploadURL;
        link.textContent = value.split('/').pop();
        row.appendChild(link);
      } else {
        row.appendChild(document.createTextNode(value));
      }
      container.appendChild(row);
    });
  }
  document.addEventListener('submit', function (event) {
    if (!groupFor(event.target)) return;
    if (!validate(event.target, true)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('input', function (event) {
    if (event.target.closest('[data-bp-personalization]') && event.target.form) validate(event.target.form, false);
  });
  document.addEventListener('reset', function (event) {
    var group = groupFor(event.target);
    if (!group) return;
    group.querySelectorAll('input').forEach(function (field) { field.setCustomValidity(''); });
    var error = group.querySelector('[data-bp-personalization-error]');
    if (error) { error.hidden = true; error.textContent = ''; }
  });
  window.BPPersonalization = { validate: validate, renderProperties: renderProperties };
}());

